import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  ActivityIndicator,
  Modal,
  Text,
  TouchableOpacity,
  View,
  Image,
} from "react-native";

import { useRoute } from "@react-navigation/native";
import axios from "axios";
import * as DocumentPicker from "expo-document-picker";
import { LinearGradient } from "expo-linear-gradient";
import api from "../../services/api";
import { toast } from "../../utils/toast";
import Logo from "../../../assets/logo-gpx-ecofi.png";
import NumberInput from "../../components/NumberInput";
import AuthCodeInput from "../../components/Form/AuthCodeInput";
import Input from "../../components/Form/Input";
import MaskedInput from "../../components/Form/MaskedInput";
import styles from "./style";

import moment from "moment";

import { RootSiblingParent } from "react-native-root-siblings";
import ModalSuccess from "../../components/ModalSuccess";
import { Case, Else, If, Switch, Then, When } from "react-if";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { navigate } from "../../utils/navigation";

const customTextStyle = { color: "#FFF", fontSize: "16px" };

const documentFormat = {
  "pt-BR": "999.999.999-99",
  it: "AAA AAA 99A99 A999A",
};

const validators = {
  "pt-BR": (cpf) => cpf.length === 14,
  it: (cpf) => cpf.length === 16,
};

function compareStrings(stringA, stringB) {
  const manipulatedA = stringA.toLowerCase().replace(/[^0-9a-z ]/g, "");
  const manipulatedB = stringB.toLowerCase().replace(/[^0-9a-z ]/g, "");
  const splittedBySpaceA = manipulatedA.split(" ");
  const splittedBySpaceB = manipulatedB.split(" ");

  let valid = false;
  //condições de validação
  let sizeA = splittedBySpaceA.length;
  let sizeB = splittedBySpaceB.length;
  if (manipulatedA === manipulatedB) {
    valid = true;
  } else {
    if (splittedBySpaceA[0] === splittedBySpaceB[0]) {
      if (splittedBySpaceA[sizeA - 1] === splittedBySpaceB[sizeB - 1]) {
        //primeiro e último iguais
        valid = true;
      }
    }
    if (splittedBySpaceA.join("") === splittedBySpaceB.join("")) {
      //sao iguais sem espaço e manipulados
      valid = true;
    }

    if (!valid) {
      let alphaStringA = {
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0,
        l: 0,
        m: 0,
        n: 0,
        o: 0,
        p: 0,
        q: 0,
        r: 0,
        s: 0,
        t: 0,
        u: 0,
        v: 0,
        w: 0,
        x: 0,
        y: 0,
        z: 0,
      };
      let alphaStringB = {
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0,
        l: 0,
        m: 0,
        n: 0,
        o: 0,
        p: 0,
        q: 0,
        r: 0,
        s: 0,
        t: 0,
        u: 0,
        v: 0,
        w: 0,
        x: 0,
        y: 0,
        z: 0,
      };
      const splittedA = manipulatedA.split("");
      const splittedB = manipulatedB.split("");
      for (let i = 0; i < splittedA.length; i++) {
        let letter = splittedA[i];
        if (alphaStringA[letter] || alphaStringA[letter] === 0) {
          alphaStringA[letter]++;
        }
      }
      for (let i = 0; i < splittedB.length; i++) {
        let letter = splittedB[i];
        if (alphaStringB[letter] || alphaStringB[letter] === 0) {
          alphaStringB[letter]++;
        }
      }
      let consideredLength = Math.max(manipulatedA.length, manipulatedB.length);
      let countDiference = 0;
      for (var keyA in alphaStringA) {
        if (
          alphaStringA.hasOwnProperty(keyA) &&
          alphaStringB.hasOwnProperty(keyA)
        ) {
          countDiference += Math.abs(alphaStringA[keyA] - alphaStringB[keyA]);
        }
      }
      if (countDiference <= Math.ceil(0.5 * consideredLength)) {
        valid = true;
      }
    }
  }
  return valid;
}

export default function Register({ navigation }) {
  const progressValue = 1 / 9;

  const [errors, setErrors] = useState({});

  const [authId, setAuthId] = useState("");
  const [formStep, setFormStep] = useState(-1);
  const [progress, setProgress] = useState(progressValue);
  const [isLoading, setIsLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const [rg, setRg] = useState("");
  const [cpf, setCpf] = useState("");
  const [name, setName] = useState("");
  const [auth, setAuth] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [birthday, setBirthday] = useState("");
  const [foreign, setForeign] = useState(false);
  const [passport, setPassport] = useState();
  const [password_confirmation, setPasswordConfirmation] = useState("");
  const [document, setDocument] = useState(0);
  const [socialReason, setSocialreason] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [cpfLegalResponsible, setCpfLegalResponsible] = useState("");
  const [nameLegalResponsible, setNameLegalResponsible] = useState("");
  const [socialContractLegalResponsible, setSocialContractLegalResponsible] =
    useState(null);
  const [country, setCountry] = useState("");
  const [language, setLanguage] = useState("");
  const route = useRoute();
  const { lang } = route.params;
  const [setLang] = useState("");

  const handleBtnCountry = async (country, language) => {
    setCountry(country);
    setLanguage(language);
    /* const languageMap = {
      brasil: "pt-br",
      italia: "it",
    };
    language = languageMap[country] || "pt-br"; */

    await AsyncStorage.setItem("@country", country);
    await AsyncStorage.setItem("@language", language);
    setFormStep(0);
  };

  useEffect(() => {
    (async () => {
      setCountry((await AsyncStorage.getItem("@country")) || "");
      setLanguage((await AsyncStorage.getItem("@language")) || "");
      setAuthId((await AsyncStorage.getItem("@authId")) || "");
      setFormStep(parseInt((await AsyncStorage.getItem("@formStep")) || "-1"));
      setCpf((await AsyncStorage.getItem("@cpf")) || "");
      setName((await AsyncStorage.getItem("@name")) || "");
      setAuth((await AsyncStorage.getItem("@auth")) || "");
      setEmail((await AsyncStorage.getItem("@email")) || "");
      setBirthday((await AsyncStorage.getItem("@birthday")) || "");
      setDocument(parseInt((await AsyncStorage.getItem("@document")) || "0"));
      setSocialreason((await AsyncStorage.getItem("@socialreason")) || "");
      setCnpj((await AsyncStorage.getItem("@cnpj")) || "");
      setCpfLegalResponsible(
        (await AsyncStorage.getItem("@cpfLegalResponsible")) || ""
      );
      setNameLegalResponsible(
        (await AsyncStorage.getItem("@nameLegalResponsible")) || ""
      );
      setSocialContractLegalResponsible(
        (await AsyncStorage.getItem("@socialContractLegalResponsible")) || ""
      );
    })();
  }, []);

  const intl = useIntl();

  function isFirstStep() {
    const firstStep = document === 2 ? 9 : 0;
    return formStep == firstStep;
  }

  async function handleCodeVerification() {
    setIsLoading(true);
    try {
      await api.post(`emails/${authId}/confirm-email`, {
        confirmation_code: parseInt(auth),
      });
      handleStepChange();
    } catch ({ response }) {
      const { status } = response;
      if (status === 403) {
        const { data } = response;
        setErrors({ auth: data.message });
        //authInputField.current.focus()
        setAuth(0);
      } else {
        toast(intl.formatMessage({ id: "register.erroInesperado" }), "#DA1414");
      }
    } finally {
      setIsLoading(false);
    }
  }

  async function handleSendCodeRequest() {
    setIsLoading(true);
    try {
      const response = await api.post("/emails/signup", { email: email });
      await AsyncStorage.setItem("@authId", response.data.id);
      setAuthId(response.data.id);
      handleStepChange();
    } catch (error) {
      console.error(error);
      let response = error.response;
      const { status } = response;

      if (status === 422) {
        const { data } = response;
        const { email } = data.message;
        toast(email[0], "#DA1414", 3000);
      } else {
        toast(intl.formatMessage({ id: "register.erroInesperado" }));
      }
    } finally {
      setIsLoading(false);
    }
  }

  function resetLocalState() {
    setAuthId("");
    setFormStep(-1);
    setCpf("");
    setName("");
    setAuth(0);
    setEmail("");
    setBirthday("");
    setDocument(0);
    setSocialreason("");
    setCnpj("");
    setCpfLegalResponsible("");
    setNameLegalResponsible("");
    setSocialContractLegalResponsible(null);
    setPassword("");
    setPasswordConfirmation("");
    setRg("");
    setPassport(undefined);
    setForeign(false);
    setErrors({});
    setProgress(progressValue);
    setIsLoading(false);
    setCountry("");
    setLanguage("");
  }

  async function clearFormStorage() {
    try {
      await AsyncStorage.multiRemove([
        "@authId",
        "@formStep",
        "@cpf",
        "@name",
        "@auth",
        "@email",
        "@birthday",
        "@document",
        "@socialreason",
        "@cnpj",
        "@cpfLegalResponsible",
        "@nameLegalResponsible",
        "@socialContractLegalResponsible",
        "@country",
        "@language",
      ]);
    } catch (error) {
      console.error;
    }
  }

  async function handleSignup(data) {
    setIsLoading(true);
    try {
      await api.post("/clients/signup", data);
      setModalVisible(true);
      setProgress(1);
      await clearFormStorage();
      resetLocalState();
    } catch ({ response }) {
      const { status } = response;
      if (status === 422) {
        toast(
          intl.formatMessage({ id: "register.erroCamposPreenchidos" }),
          "#000",
          3000
        );
      } else {
        toast(
          intl.formatMessage({ id: "register.erroInesperado" }),
          "#000",
          3000
        );
      }
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    const handleBeforeUnload = async (event) => {
      await clearFormStorage();
      resetLocalState();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  /*                     currentStep) => {
        AsyncStorage.setItem("@formStep", currentStep - 1);
        return currentStep - 1;
      });
    } else {
      setProgress((currentProgress) => currentProgress + progressValue);
      setFormStep((currentStep) => {
        AsyncStorage.setItem("@formStep", currentStep + 1);
        return currentStep + 1;
      });
    }
  }
 */

  function handleStepChange(isForward = true, close = false) {
    if (!isForward) {
      if (isFirstStep() || close) navigation.navigate("Welcome");
      setProgress((currentProgress) => currentProgress - progressValue);
      setFormStep((currentStep) => {
        AsyncStorage.setItem("@formStep", (currentStep - 1).toString());
        return currentStep - 1;
      });
    } else {
      setProgress((currentProgress) => currentProgress + progressValue);
      setFormStep((currentStep) => {
        AsyncStorage.setItem("@formStep", (currentStep + 1).toString());
        return currentStep + 1;
      });
    }
  }

  useEffect(() => {
    (async () => {
      setAuthId((await AsyncStorage.getItem("@authId")) || "");
      setFormStep(parseInt((await AsyncStorage.getItem("@formStep")) || "-1"));
      setCountry((await AsyncStorage.getItem("@country")) || "");
      setCountry((await AsyncStorage.getItem("@language")) || "");
      setCpf((await AsyncStorage.getItem("@cpf")) || "");
      setName((await AsyncStorage.getItem("@name")) || "");
      setAuth((await AsyncStorage.getItem("@auth")) || "");
      setEmail((await AsyncStorage.getItem("@email")) || "");
      setBirthday((await AsyncStorage.getItem("@birthday")) || "");
      setDocument(parseInt((await AsyncStorage.getItem("@document")) || "0"));
      setSocialreason((await AsyncStorage.getItem("@socialreason")) || "");
      setCnpj((await AsyncStorage.getItem("@cnpj")) || "");
      setCpfLegalResponsible(
        (await AsyncStorage.getItem("@cpfLegalResponsible")) || ""
      );
      setNameLegalResponsible(
        (await AsyncStorage.getItem("@nameLegalResponsible")) || ""
      );
      setSocialContractLegalResponsible(
        (await AsyncStorage.getItem("@socialContractLegalResponsible")) || ""
      );
    })();
  }, []);

  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const erroDataFutura = intl.formatMessage({
    id: "register.erroDataFutura",
  });
  const nameErrorMsg = intl.formatMessage({
    id: "register.erroNecessarioNome",
  });
  const birthdayErrorMsg = intl.formatMessage({
    id: "register.erroNecessarioDataNasc",
  });
  const dataInvalidaErrorMsg = intl.formatMessage({
    id: "register.erroNecessarioDataValida",
  });
  const cpfErrorMsg = intl.formatMessage({ id: "register.erroNecessarioCPF" });
  const cpfInvalidoErrorMsg = intl.formatMessage({
    id: "register.erroCpfInvalido",
  });
  const cpfUtilizadoErrorMsg = intl.formatMessage({
    id: "register.erroCpfUtilizado",
  });
  const cpfValidaErrorMsg = intl.formatMessage({
    id: "register.erroValidaCpf",
  });
  const nomeValidaErrorMsg = intl.formatMessage({
    id: "register.erroValidaNome",
  });
  const cpfBigDataErrorMsg = intl.formatMessage({
    id: "register.erroCpfBigData",
  });
  const informaEmailErrorMsg = intl.formatMessage({
    id: "register.erroInformaEmail",
  });
  const informaEmailValidoErrorMsg = intl.formatMessage({
    id: "register.erroInformaEmailValido",
  });
  const codigoValidacaoErrorMsg = intl.formatMessage({
    id: "register.erroCodigoValidacao",
  });
  const codigo4DigtsErrorMsg = intl.formatMessage({
    id: "register.erroCodigo4Digitos",
  });
  const informaSenhaErrorMsg = intl.formatMessage({
    id: "register.erroInformaSenha",
  });
  const senha6DigitsErrorMsg = intl.formatMessage({
    id: "register.erroSenha6Digitos",
  });
  const confirmaSenhaErrorMsg = intl.formatMessage({
    id: "register.erroConfirmaSenha",
  });
  const senhasPareadasErrorMsg = intl.formatMessage({
    id: "register.erroSenhasPareadas",
  });
  const razaoSocialErrorMsg = intl.formatMessage({
    id: "register.erroRazaoSocial",
  });
  const informaCnpjErrorMsg = intl.formatMessage({
    id: "register.erroInformaCnpj",
  });
  const cnpjInvalidoErrorMsg = intl.formatMessage({
    id: "register.erroCnpjInvalido",
  });
  const cnpjUtilizadoErrorMsg = intl.formatMessage({
    id: "register.erroCnpjUtilizado",
  });
  const razaoNaoCompativelErrorMsg = intl.formatMessage({
    id: "register.erroRazaoNaoCompativel",
  });
  const dadosCnpjErrorMsg = intl.formatMessage({
    id: "register.erroDadosCnpj",
  });
  const informaCpfResponsavelErrorMsg = intl.formatMessage({
    id: "register.erroInformaCpfResponsavel",
  });
  const informaNomeResponsavelErrorMsg = intl.formatMessage({
    id: "register.erroInformaNomeResponsavel",
  });

  async function isValidForm() {
    switch (formStep) {
      case 1:
        if (!name) {
          setErrors({ name: nameErrorMsg });
          return false;
        }
        return true;

      case 2:
        const validDate = moment(birthday, "DD/MM/YYYY", true).isValid();
        if (!birthday) {
          setErrors({
            birthday: birthdayErrorMsg,
          });
          return false;
        }
        if (!validDate) {
          setErrors({
            birthday: dataInvalidaErrorMsg,
          });
          return false;
        }

        // Verificar se a data inserida é uma data futura
        const currentDate = new Date();
        const inputDate = new Date(
          birthday.substring(6, 10),
          birthday.substring(3, 5) - 1,
          birthday.substring(0, 2)
        );

        if (inputDate > currentDate) {
          setErrors({
            birthday: erroDataFutura,
          });
          return false;
        }
        return true;
      case 3:
        if (!cpf) {
          setErrors({
            cpf: cpfErrorMsg,
          });
          return false;
        }

        /* if (cpf.length < 14) {
          setErrors({
            cpf: cpfInvalidoErrorMsg,
          });
          return false;
        } */

        if (lang === "pt-br") {
          var data = JSON.stringify({
            Datasets: "basic_data",
            q: `doc{${cpf}}`,
            AccessToken: "5a066da6-c5aa-40f8-809d-f0c14dd73b73",
          });

          var config = {
            method: "post",
            url: "https://bigboost.bigdatacorp.com.br/peoplev2",
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };

          return await axios(config)
            .then(function (response) {
              if (response.data.Status.basic_data[0].Code != 0) {
                setErrors({
                  cpf: cpfInvalidoErrorMsg,
                });
                return false;
              }

              const DateBigData = moment
                .utc(response.data.Result[0].BasicData.BirthDate)
                .locale("pt-br")
                .format("L");

              if (DateBigData != birthday) {
                setErrors({
                  cpf: cpfValidaErrorMsg,
                });
                return false;
              }

              const NameBigData = response.data.Result[0].BasicData.Name;

              let valid = compareStrings(NameBigData, name);

              if (!valid) {
                //  console.log(NameBigData.toLowerCase(), name.toLowerCase())
                setErrors({
                  cpf: nomeValidaErrorMsg,
                });
                return false;
              }

              return true;
            })
            .catch(function (error) {
              setErrors({
                cpf: cpfBigDataErrorMsg,
              });
              return false;
            });
        }

        const letters = Array.from(Array(12)).map((e, i) =>
          String.fromCharCode(i + 65)
        );

        //TODO: ajustar a validação
        let valid = (validators[lang] || validators.it)(cpf);
        //&&
        //name.replace(/[aeiouà-ú ]/gi, '').substring(0, 6).toUpperCase() === cpf.substring(0, 6).toUpperCase() &&
        //cpf.substring(6, 8) ===  birthday.substring(8, 10) &&
        //cpf.charAt(8).toUpperCase() === letters[birthday.substring(3, 5) - 1] &&
        //cpf.substring(9,11) === birthday.substring(0, 2);

        if (!valid) {
          setErrors({
            cpf: cpfInvalidoErrorMsg,
          });
          return false;
        }

        let used;
        setIsLoading(true);
        try {
          const response = await api.post("/clients/checkCpfCnpj", {
            cpfCnpj: cpf || cnpj,
          });
          used = response.data.message === "used";
        } catch (err) {
          console.log(err?.response?.data);
          used = err?.response?.data?.message === "used";
          setErrors({
            cpf: cpfUtilizadoErrorMsg,
          });
        } finally {
          setIsLoading(false);
          return !used;
        }

      case 4:
        if (!email) {
          setErrors({
            email: informaEmailErrorMsg,
          });
          return false;
        }

        if (email && !validateEmail(email)) {
          setErrors({
            email: informaEmailValidoErrorMsg,
          });
          return false;
        }
        return true;
      case 5:
        if (!auth) {
          setErrors({
            auth: codigoValidacaoErrorMsg,
          });
          return false;
        }

        if (auth.length < 4) {
          setErrors({
            auth: codigo4DigtsErrorMsg,
          });
          return false;
        }

        return true;
      case 6:
        if (!password) {
          setErrors({
            password: informaSenhaErrorMsg,
          });
          return false;
        }

        if (password.length < 6) {
          setErrors({
            password: senha6DigitsErrorMsg,
          });
          return false;
        }

        if (!password_confirmation) {
          setErrors({
            password_confirmation: confirmaSenhaErrorMsg,
          });
          return false;
        }

        if (password !== password_confirmation) {
          setErrors({
            password_confirmation: senhasPareadasErrorMsg,
          });
          return false;
        }

        return true;

      case 9:
        if (!socialReason) {
          setErrors({ socialReason: razaoSocialErrorMsg });
          return false;
        }

        return true;

      case 10:
        if (!cnpj) {
          setErrors({
            cnpj: informaCnpjErrorMsg,
          });
          return false;
        }
        if (cnpj.length < 18) {
          setErrors({
            cnpj: cnpjInvalidoErrorMsg,
          });
          return false;
        }
        setIsLoading(true);
        try {
          const response = await api.post("/clients/checkCpfCnpj", {
            cpfCnpj: cpf || cnpj,
          });
          if (response.data.message !== "free") {
            setErrors({
              cnpj: cnpjUtilizadoErrorMsg,
            });
            return false;
          }
        } catch (err) {
          console.log(err?.response?.data);
          used = err?.response?.data?.message === "used";
          setErrors({
            cnpj: cnpjUtilizadoErrorMsg,
          });
        } finally {
          setIsLoading(false);
        }

        // Verifica se a linguagem é "it"
        if (lang !== "it") {
          return await api
            .post("https://api.gpxecofi.com.br/api/cors", {
              Datasets: "basic_data",
              q: `doc{${cnpj}}`,
              AccessToken: "5a066da6-c5aa-40f8-809d-f0c14dd73b73",
              url: "https://bigboost.bigdatacorp.com.br/companies",
            })
            .then(function (response) {
              if (response.data.Status.basic_data[0].Code != 0) {
                setErrors({
                  cnpj: cnpjInvalidoErrorMsg,
                });
                return false;
              }

              const RazaoSocial =
                response.data.Result[0].BasicData.OfficialName;
              console.log("RazaoSocial", RazaoSocial);

              /*      let valid =
                socialReason.toLowerCase().replace(/[^0-9a-z ]/g, "") ===
                RazaoSocial.toLowerCase().replace(/[^0-9a-z ]/g, ""); */
              let valid =
                socialReason.toUpperCase().replace(/[^0-9a-z ]/g, "") ===
                RazaoSocial.toUpperCase().replace(/[^0-9a-z ]/g, "");

              // Verifica se a razão social é compatível
              if (!valid) {
                setErrors({ cnpj: razaoNaoCompativelErrorMsg });
                return false;
              }

              return true;
            })
            .catch(function (error) {
              setErrors({
                cnpj: dadosCnpjErrorMsg,
              });
              return false;
            });
        }

        // Se a linguagem for "it", apenas retorna true sem fazer a validação
        return true;

      case 11:
        if (!cpfLegalResponsible) {
          setErrors({
            cpfLegalResponsible: informaCpfResponsavelErrorMsg,
          });
          return false;
        }

        if (!nameLegalResponsible) {
          setErrors({
            nameLegalResponsible: informaNomeResponsavelErrorMsg,
          });
          return false;
        }

        //TIRAR ESSE AQUI:
        return true;

        var data = JSON.stringify({
          Datasets: "basic_data",
          q: `doc{${cpfLegalResponsible}}`,
          AccessToken: "5a066da6-c5aa-40f8-809d-f0c14dd73b73",
          url: "https://bigboost.bigdatacorp.com.br/peoplev2",
        });

        var config = {
          method: "post",
          url: "https://api.gpxecofi.com.br/api/cors",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
      case 12:
        if (!email) {
          setErrors({
            email: informaEmailErrorMsg,
          });
          return false;
        }

        if (email && !validateEmail(email)) {
          setErrors({
            email: informaEmailValidoErrorMsg,
          });
          return false;
        }
        return true;

      case 13:
        if (!auth) {
          setErrors({
            auth: codigoValidacaoErrorMsg,
          });
          return false;
        }

        if (auth.length < 4) {
          setErrors({
            auth: codigo4DigtsErrorMsg,
          });
          return false;
        }

        return true;
      case 14:
        if (!password) {
          setErrors({
            password: informaSenhaErrorMsg,
          });
          return false;
        }

        if (password.length < 6) {
          setErrors({
            password: senha6DigitsErrorMsg,
          });
          return false;
        }
        if (!password_confirmation) {
          setErrors({
            password_confirmation: confirmaSenhaErrorMsg,
          });
          return false;
        }

        if (password !== password_confirmation) {
          setErrors({
            password_confirmation: senhasPareadasErrorMsg,
          });
          return false;
        }

        return true;
    }
  }

  async function handleSubmit() {
    if (!(await isValidForm())) return;

    setErrors({});

    if (document === 1) {
      if (formStep == 4) {
        handleSendCodeRequest();
        return;
      }

      if (formStep == 5) {
        handleCodeVerification();
        return;
      }
    } else {
      if (formStep == 12) {
        handleSendCodeRequest();
        return;
      }

      if (formStep == 13) {
        handleCodeVerification();
        return;
      }
    }

    if (document === 1) {
      if (formStep === 6) {
        const splitedName = name.split(" ");
        const firstName = splitedName.shift();
        const lastNames = splitedName.join(" ");

        const data = {
          user: {
            email,
            password,
            email_id: authId,
          },
          client: {
            cpf,
            passport,
            rg_number: rg,
            first_name: firstName,
            last_name: lastNames,
            birthday: moment(birthday, "DD/MM/YYYY").format("YYYY-MM-DD"),
            socialReason: "",
            cnpj: "",
            cpfLegalResponsible: "",
            nameLegalResponsible: "",
            socialContractLegalResponsible: "",
            is_pj: false,
            country,
            language,
          },
          address: {
            country_id: country === "brasil" ? 31 : 108,
          },
        };

        handleSignup(data);
      } else {
        handleStepChange();
      }
    } else {
      if (formStep === 14) {
        // const splitedName = name.split(" ");
        // const firstName = splitedName.shift();
        // const lastNames = splitedName.join(" ");

        const data = {
          user: {
            email,
            password,
            email_id: authId,
          },
          client: {
            cpf: "",
            passport: "",
            rg_number: "",
            first_name: socialReason,
            last_name: "",
            birthday: "",
            socialReason,
            cnpj,
            cpfLegalResponsible,
            nameLegalResponsible,
            socialContractLegalResponsible,
            is_pj: true,
            country,
            language,
          },
          address: {
            country_id: country === "brasil" ? 31 : 108,
          },
        };

        handleSignup(data);
      } else {
        handleStepChange();
      }
    }
  }

  const pickDocument = async () => {
    let result = await DocumentPicker.getDocumentAsync({});

    if (result.cancelled) {
      return false;
    }

    let localUri = result.uri;
    let filename = localUri.split("/").pop();

    let match = /\.(\w+)$/.exec(filename);
    let type = match ? `image/${match[1]}` : `image`;

    setSocialContractLegalResponsible(result);
  };

  const goBack = () => {
    if (formStep === 9) {
      setFormStep(0);
    } else if (formStep === 0) {
      setFormStep(-1);
    } else if (formStep === -1) {
      navigation.navigate("Welcome");
      clearFormStorage();
    } else {
      setFormStep((prevStep) => Math.max(prevStep - 1, 0));
    }
  };

  return (
    <RootSiblingParent>
      <View style={styles.container}>
        <LinearGradient
          start={{ x: 1, y: 0.99 }}
          end={{ x: 1, y: 1 }}
          colors={["#077A97", "#A3CED8"]}
          style={styles.bgLinearGradient}
        >
          <View style={styles.formGeral}>
            <If condition={formStep === -1}>
              <Then>
                <View style={{ flexDirection: "column", gap: 12 }}>
                  <Text style={customTextStyle}>
                    <FormattedMessage id="register.lblSelecioneMercado" />
                  </Text>
                  <TouchableOpacity
                    onPress={async () => {
                      handleBtnCountry("brasil", "pt-BR");
                      await AsyncStorage.setItem("@country", "brasil");
                      await AsyncStorage.setItem("@language", "pt-BR");
                    }}
                    style={[styles.btnPais]}
                  >
                    <Text style={styles.buttonTexto}>
                      🇧🇷
                      <FormattedMessage id="register.btnBrasil" />
                    </Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    onPress={async () => {
                      handleBtnCountry("italia", "it");
                      await AsyncStorage.setItem("@country", "italia");
                      await AsyncStorage.setItem("@language", "it");
                    }}
                    style={[styles.btnPais]}
                  >
                    <Text style={styles.buttonTexto}>
                      🇮🇹 <FormattedMessage id="register.btnItalia" />
                    </Text>
                  </TouchableOpacity>
                </View>
              </Then>
            </If>
            <When condition={formStep === 0}>
              <View style={{ flexDirection: "column" }}>
                <View style={styles.form}>
                  <Text style={customTextStyle}>
                    <FormattedMessage id="register.lblTipoConta" />
                  </Text>
                  <TouchableOpacity
                    onPress={async () => {
                      handleSubmit();
                      setDocument(1);
                      setFormStep(1); // Se selecionado pessoa física, vá para etapa 1
                      await AsyncStorage.setItem("@document", 1);
                      await AsyncStorage.setItem("@formStep", 1);
                    }}
                    style={[styles.button, styles.btnTipoConta]}
                  >
                    <Text style={[styles.buttonTexto]}>
                      <FormattedMessage id="register.pessoaFisica" />
                    </Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    onPress={async () => {
                      handleSubmit();
                      setDocument(2);
                      setFormStep(9); // Se selecionado pessoa jurídica, vá para etapa 8
                      await AsyncStorage.setItem("@document", 2);
                      await AsyncStorage.setItem("@formStep", 9);
                    }}
                    style={[styles.button, styles.pj]}
                  >
                    <Text style={[styles.buttonTexto]}>
                      <FormattedMessage id="register.pessoaJuridica" />
                    </Text>
                  </TouchableOpacity>

                  <TouchableOpacity onPress={goBack} style={styles.btnVoltar}>
                    <Text style={styles.btnVoltarText}>
                      <FormattedMessage id="goBackButton.labelVoltar" />
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </When>
            <View style={{ flex: 1 }}>
              <View style={styles.geral}>
                <Switch>
                  <Case condition={formStep === 1}>
                    <FormattedMessage id="register.digiteNome">
                      {(label) => (
                        <Input
                          label={<Text style={customTextStyle}>{label}</Text>}
                          value={name}
                          onValueChange={async (value) => {
                            setName(value);
                            await AsyncStorage.setItem("@name", value);
                          }}
                          error={errors.name}
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  <Case condition={formStep === 2}>
                    <FormattedMessage id="register.dataNascimento">
                      {(label) => (
                        <MaskedInput
                          value={birthday}
                          mask="99/99/9999"
                          keyboardType="numeric"
                          label={label}
                          onValueChange={async (value) => {
                            setBirthday(value);
                            await AsyncStorage.setItem("@birthday", value);
                          }}
                          error={errors.birthday}
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  <Case condition={formStep === 3}>
                    <FormattedMessage id="register.cpf">
                      {(label) => (
                        <MaskedInput
                          mask={documentFormat[lang] || documentFormat["it"]}
                          label={label}
                          value={cpf}
                          onValueChange={async (value) => {
                            setCpf(value.replaceAll(" ", ""));
                            await AsyncStorage.setItem(
                              "@cpf",
                              value.replaceAll(" ", "")
                            );
                          }}
                          error={errors.cpf}
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  <Case condition={formStep === 4}>
                    <FormattedMessage id="register.email">
                      {(label) => (
                        <Input
                          label={<Text style={customTextStyle}>{label}</Text>}
                          value={email}
                          onValueChange={async (value) => {
                            setEmail(value);
                            await AsyncStorage.setItem("@email", value);
                          }}
                          error={errors.email}
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  <Case condition={formStep === 5}>
                    <FormattedMessage id="register.msgCodigoEmail">
                      {(label) => (
                        <AuthCodeInput
                          cellCount={4}
                          value={auth}
                          onValueChange={(value) => setAuth(value)}
                          label={<Text style={customTextStyle}>{label}</Text>}
                          error={errors.auth}
                          focus
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  <Case condition={formStep === 6}>
                    <FormattedMessage id="register.crieSenha">
                      {(label) => (
                        <AuthCodeInput
                          cellCount={6}
                          value={password}
                          onValueChange={(value) => setPassword(value)}
                          label={<Text style={customTextStyle}>{label}</Text>}
                          error={errors.password}
                          isPassword
                        />
                      )}
                    </FormattedMessage>
                    <Text>{"\n"}</Text>
                    <FormattedMessage id="register.confirmeSenha">
                      {(label) => (
                        <AuthCodeInput
                          cellCount={6}
                          value={password_confirmation}
                          onValueChange={(value) =>
                            setPasswordConfirmation(value)
                          }
                          label={<Text style={customTextStyle}>{label}</Text>}
                          error={errors.password_confirmation}
                          isPassword
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  {/* <Case condition={formStep === 8}></Case> */}
                  <Case condition={formStep === 9}>
                    <FormattedMessage id="register.razaoSocial">
                      {(label) => (
                        <Input
                          label={<Text style={customTextStyle}>{label}</Text>}
                          value={socialReason}
                          onValueChange={async (value) => {
                            setSocialreason(value);
                            await AsyncStorage.setItem("@socialReason", value);
                          }}
                          error={errors.socialReason}
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  <Case condition={formStep === 10}>
                    <FormattedMessage id="register.CNPJ">
                      {(label) => (
                        <MaskedInput
                          mask={
                            lang === "it" ? "99999999999" : "99.999.999/9999-99"
                          }
                          label={label}
                          value={cnpj}
                          onValueChange={async (value) => {
                            setCnpj(value);
                            await AsyncStorage.setItem("@cnpj", value);
                          }}
                          error={errors.cnpj}
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  <Case condition={formStep === 11}>
                    <FormattedMessage id="register.CpfResponsavelLegal">
                      {(label) => (
                        <MaskedInput
                          mask={documentFormat[lang] || documentFormat["it"]}
                          label={label}
                          value={cpfLegalResponsible}
                          onValueChange={async (value) => {
                            setCpfLegalResponsible(value);
                            await AsyncStorage.setItem(
                              "@cpfLegalResponsible",
                              value
                            );
                          }}
                          error={errors.cpfLegalResponsible}
                        />
                      )}
                    </FormattedMessage>
                    <FormattedMessage id="register.nomeResponsavelLegal">
                      {(label) => (
                        <Input
                          label={<Text style={customTextStyle}>{label}</Text>}
                          value={nameLegalResponsible}
                          onValueChange={async (value) => {
                            setNameLegalResponsible(value);
                            await AsyncStorage.setItem(
                              "@nameLegalResponsible",
                              value
                            );
                          }}
                          error={errors.nameLegalResponsible}
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  <Case condition={formStep === 12}>
                    <FormattedMessage id="register.digiteEmail">
                      {(label) => (
                        <Input
                          label={<Text style={customTextStyle}>{label}</Text>}
                          value={email}
                          onValueChange={async (value) => {
                            setEmail(value);
                            await AsyncStorage.setItem("@email", value);
                          }}
                          error={errors.email}
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  <Case condition={formStep === 13}>
                    <FormattedMessage id="register.codigoEmail">
                      {(label) => (
                        <AuthCodeInput
                          cellCount={4}
                          value={auth}
                          onValueChange={(value) => {
                            setAuth(value);
                          }}
                          label={<Text style={customTextStyle}>{label}</Text>}
                          error={errors.auth}
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                  <Case condition={formStep === 14}>
                    <FormattedMessage id="register.crieSuaSenha">
                      {(label) => (
                        <AuthCodeInput
                          cellCount={6}
                          value={password}
                          onValueChange={(value) => setPassword(value)}
                          label={<Text style={customTextStyle}>{label}</Text>}
                          error={errors.password}
                          isPassword
                          focus={true}
                          isFocusOnCreatePassword={true}
                        />
                      )}
                    </FormattedMessage>
                    <Text>{"\n"}</Text>
                    <FormattedMessage id="register.confirmeSenha">
                      {(label) => (
                        <AuthCodeInput
                          cellCount={6}
                          value={password_confirmation}
                          onValueChange={(value) =>
                            setPasswordConfirmation(value)
                          }
                          label={<Text style={customTextStyle}>{label}</Text>}
                          error={errors.password_confirmation}
                          isPassword
                          focus={false}
                        />
                      )}
                    </FormattedMessage>
                  </Case>
                </Switch>
              </View>

              <View style={styles.actionContainer}>
                <When condition={formStep !== 0}>
                  <If condition={formStep !== -1}>
                    <Then>
                      <TouchableOpacity
                        onPress={handleSubmit}
                        style={styles.button}
                      >
                        <If condition={isLoading}>
                          <Then>
                            <ActivityIndicator color="#FFF" size="large" />
                          </Then>
                          <Else>
                            <When
                              condition={
                                document === 1 || formStep < 6 || formStep <= 14
                              }
                            >
                              <Text style={styles.textButtonContinuar}>
                                <FormattedMessage
                                  id={`register.${
                                    formStep < 14 ? "continuar" : "cadastrar"
                                  }`}
                                />
                              </Text>
                            </When>
                          </Else>
                        </If>
                      </TouchableOpacity>
                    </Then>
                  </If>

                  <TouchableOpacity onPress={goBack} style={styles.btnVoltar}>
                    <Text style={styles.btnVoltarText}>
                      <FormattedMessage id="goBackButton.labelVoltar" />
                    </Text>
                  </TouchableOpacity>
                </When>
                <Image style={styles.image2} source={Logo} />
              </View>
              <Modal
                animationType="fade"
                transparent={false}
                visible={modalVisible}
                statusBarTranslucent={true}
                onRequestClose={() => setModalVisible((visible) => !visible)}
              >
                <FormattedMessage id="register.contaCriadaColor">
                  {(textColor) => (
                    <FormattedMessage id="register.contaCriada">
                      {(textContaCriada) => (
                        <ModalSuccess
                          handleCloseModal={() => {
                            setModalVisible(false);
                            navigation.navigate("Login");
                          }}
                          text={textContaCriada}
                          textColor={textColor}
                          subtitle={""}
                          img={1}
                          positionHeader={"right"}
                        />
                      )}
                    </FormattedMessage>
                  )}
                </FormattedMessage>
              </Modal>
            </View>
          </View>
        </LinearGradient>
      </View>
    </RootSiblingParent>
  );
}
